// extracted by mini-css-extract-plugin
export default {"section":"profile_section__VbQzG"};